const classmap = {
  item: '[data-step-item]'
}

const attr = {
  title: 'data-original-title',
  replace: 'data-replace-with-name'
}

const fillInName = ({ target, detail }) => {
  if (detail && !detail.user) return

  const bubblingTarget = target.closest(classmap.item)
  if (!bubblingTarget) return

  const titleTarget = bubblingTarget.querySelector('[data-replace-with-name]')
  if (!titleTarget) return

  const { user } = detail

  /**
   * when the value of the title has already been changed, we recover the value in the [data-original-title]
   */
  const originalTitle = titleTarget.hasAttribute(attr.title)
    ? titleTarget.getAttribute(attr.title)
    : titleTarget.textContent

  /**
   * chooses the position to replace the name
   */
  titleTarget.textContent =
    titleTarget.getAttribute(attr.replace) === 'end'
      ? `${originalTitle} ${capitalize(user)}!`
      : `${capitalize(user)}, ${originalTitle.toLowerCase()}`

  /**
   * preserve the original title after changing it
   */
  titleTarget.setAttribute(attr.title, originalTitle)
}

const mount = () => {
  document.addEventListener('step-on-show', fillInName, false)
}

const capitalize = (val) => {
  return `${val.charAt(0).toUpperCase()}${val.slice(1)}`
}

export default { mount }
